import type { RouteObject } from 'react-router-dom'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'

export const contactInquiriesRoutes: RouteObject[] = [
  {
    path: 'admin/contact-inquiries',
    lazy: async () => ({
      Component: (
        await importWithChunkReload(() => import('./pages/contact-inquiries-page'))
      ).ContactInquiriesPage,
    }),
  },
  {
    path: 'admin/contact-inquiries/:id',
    lazy: async () => ({
      Component: (
        await importWithChunkReload(() => import('./pages/contact-inquiry-detail-page'))
      ).ContactInquiryDetailPage,
    }),
  },
]
